export default __webpack_public_path__ + "static/media/A0004.556a7c7c.png";